import { LaunchpadStatistics } from 'src/features/common/launchpad/components/launchpad-statistics';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

const AVATAR_SIZE = 120;

export const StyledWrapper = styled.div`
    box-shadow: 20px 20px 60px #bebebe, -20px -20px 60px #ffffff;
    background: linear-gradient(135deg, #ebadb6 0%, #aceae1 100%);
    min-width: 200px;
`;

export const StyledInfo = styled.div`
    padding: 55px 20px 20px;
    text-align: center;
    position: relative;
`;

export const StyledTopWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: -102px;
    z-index: 1;
    margin-bottom: 10px;
`;

export const StyledCreatorName = styled.a`
    color: ${({ theme }) => theme.colors.warmBlack};

    & > div {
        text-align: left;
    }
`;

export const StyledName = styled(FlexBox)`
    color: ${({ theme }) => theme.colors.white};

    & > div {
        position: relative;
        padding-right: 23px;
        max-width: calc(100% - 23px);
    }

    & svg {
        position: absolute;
        right: 0;
        color: ${({ theme }) => theme.colors.blue500};
        margin-left: 5px;
    }
`;

export const StyledInsetWrapper = styled.div`
    padding: 10px;
    box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.5), 5px 5px 10px 0px rgba(0, 0, 0, 0.3);
`;

export const StyledImgWrapper = styled.div`
    overflow: hidden;

    & img {
        transition: transform ${speed.content} ease-in;
    }

    &:hover img {
        transform: scale(1.1, 1.1);
    }
`;

export const StyledImgPreviewWrapper = styled.div`
    border: 2px solid ${({ theme }) => theme.colors.black};
    width: ${AVATAR_SIZE}px;
    overflow: hidden;
`;

export const StyledDescription = styled(Typography)`
    color: ${({ theme }) => theme.colors.warmBlack};
    text-align: left;
    margin-top: 10px;
    height: 40px;
`;
export const StyledStatisticItem = styled.div`
    white-space: nowrap;
    flex: 1;
`;

export const StyledStatistics = styled(FlexBox)`
    margin-top: 16px;

    & > div {
        padding: 10px;
        background: ${({ theme }) => theme.colors.black};
    }

    & > div + div {
        margin-left: 5px;
    }

    & > div:last-child {
        flex: 2;
    }
`;

export const StyledLaunchpadStatistics = styled(LaunchpadStatistics)`
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 10px;

    ${media.sm`
    width: fit-content;
    margin: 0;
    padding: 0;
    background-color: ${({ theme }: any) => theme.colors.warmBlack};
    border: 3px solid transparent;
    border-bottom: none;
    border-radius: 5px;
  `}

    ${media.md(css`
        width: min-content;
        min-width: 400px;
    `)}
`;
